import { render } from "./ToWhomScreen.vue?vue&type=template&id=e24d40f0"
import script from "./ToWhomScreen.vue?vue&type=script&lang=js"
export * from "./ToWhomScreen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Jett\\Desktop\\bg-insieme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__